import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=2e6b157a&scoped=true&"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js&"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LoadingAnimation.vue?vue&type=style&index=0&id=2e6b157a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b157a",
  null
  
)

export default component.exports